<!--
    AnotherPendant 其他挂件
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 其他挂件" name="其他挂件">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="anotherPendant" label-width="80px">
              <el-form-item label="描述">
                <el-input type="textarea" v-model="anotherPendant['描述']"></el-input>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="anotherPendant['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="anotherPendant['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="anotherPendant['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number
                  v-model="anotherPendant['数量']"
                  :min="100"
                  :max="10000"
                  label="数量"
                  style="margin:0 0 0 0;"
                ></el-input-number>
                <el-alert
                  title="单款起定数为100"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "AnotherPendant",
  data() {
    return {
      forcollapse: ["allsame"],
      anotherPendant: {
        title: "其他挂件",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.anotherPendant);
    },
    clear() {
      this.$root.clearAlert();
      this.anotherPendant = {
        title: "其他挂件",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>